import { FlowStartBlockConfigSchema } from 'flow-schema';
import { z } from 'zod';

import { ReactFlowInputParametersConfigSchema } from './parameterConfig';

export const StartBlockConfigSchema = FlowStartBlockConfigSchema.extend({
  entityType: z
    .enum(['Patient', 'Encounter', 'Order', 'ExternalDocumentPacket', 'None'])
    .optional(),
  parameters: ReactFlowInputParametersConfigSchema.optional(),
});
export type StartBlockConfig = z.infer<typeof StartBlockConfigSchema>;
